import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updateVisitAssessmentAreas = async ({
  visitId,
  patientId,
  sessionId,
  stepId,
  assessmentAreas,
  isAllAiAreas,
  disallowInvAssessmentAreasSelection,
  applyAreasToFollowing,
}) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (patientId) params.append("patient_id", patientId);
  if (sessionId) params.append("session_id", sessionId);
  if (stepId) params.append("step_id", stepId);

  const payload = { assessment_areas: assessmentAreas };
  if (isAllAiAreas !== undefined) payload.is_all_ai_areas = isAllAiAreas;
  if (disallowInvAssessmentAreasSelection !== undefined)
    payload.disallow_inv_assessment_areas_selection = disallowInvAssessmentAreasSelection;
  if (applyAreasToFollowing !== undefined) payload.apply_areas_to_following = applyAreasToFollowing;

  const res = await axios.put(
    `${__API_URL__}/api/photos/visits/${visitId}/assessment-areas/?${params.toString()}`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdateVisitAssessmentAreasMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisitAssessmentAreas,
    onSuccess: (_, variables) => {
      toast.success("Assessment areas updated");
      queryClient.invalidateQueries({ queryKey: ["visit_assessment_areas", variables.visitId] });
      queryClient.invalidateQueries({ queryKey: ["visits"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update assessment areas");
    },
  });
};

export default useUpdateVisitAssessmentAreasMutation;
